import React from 'react'

const SubmenuSolution: React.FC = (): JSX.Element => {
	return (
		<svg
			viewBox="0 0 1929 360"
			className="absolute z-1"
			style={{ zIndex: 1 }}>
			<defs>
				<style>
					{
						'.a-solution{fill:none;}.b-solution{fill:#001f5f;}.c-solution{clip-path:url(#a-solution);}.d-solution,.h-solution,.k-solution{fill:#fff;}.e-solution{fill:#e7002a;}.f-solution{fill:url(#b-solution);}.g-solution,.m-solution{opacity:0.8;}.g-solution,.j-solution,.m-solution{fill:url(#e-solution);}.h-solution{font-size:42px;}.h-solution,.k-solution{font-family:"Kiona-Bold";font-weight:700;}.i-solution{fill:url(#h-solution);}.j-solution{opacity:0.79;}.j-solution,.m-solution,.o-solution{mix-blend-mode:multiply;isolation:isolate;}.k-solution{font-size:24px;}.l-solution{fill:url(#j-solution);}.n-solution{fill:url(#l-solution);}.o-solution{filter:url(#f-solution);}.p-solution{filter:url(#c-solution);}'
					}
				</style>
				<clipPath id="a-solution">
					<rect
						className="a-solution"
						width={1427.387}
						height={206.155}
					/>
				</clipPath>
				<pattern
					id="b-solution"
					width={1}
					height={1}
					patternTransform="matrix(-1, 0, 0, 1, 1159.222, 0)"
					viewBox="125 0 455.249 260.105">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={579.611}
						height={386.407}
						xlinkHref="/images/navbar/solution-4.jpg"
					/>
				</pattern>
				<filter
					id="c-solution"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="d" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="d" />
					<feComposite in="SourceGraphic" />
				</filter>
				<linearGradient
					id="e-solution"
					x1={0.5}
					x2={0.5}
					y2={1}
					gradientUnits="objectBoundingBox">
					<stop offset={0} stopColor="#001f5f" stopOpacity={0} />
					<stop offset={1} stopColor="#001f5f" />
				</linearGradient>
				<filter
					id="f-solution"
					x={0}
					y={0}
					width={597.611}
					height={349.159}
					filterUnits="userSpaceOnUse">
					<feOffset dy={3} />
					<feGaussianBlur stdDeviation={3} result="g" />
					<feFlood floodOpacity={0.502} />
					<feComposite operator="in" in2="g" />
					<feComposite in="SourceGraphic" />
				</filter>
				<pattern
					id="h-solution"
					width={1}
					height={1}
					viewBox="43.027 54.224 436.502 182.871">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={479.529}
						height={320.034}
						xlinkHref="/images/navbar/solution-3.jpg"
					/>
				</pattern>
				<pattern
					id="j-solution"
					preserveAspectRatio="xMidYMid slice"
					width="100%"
					height="100%"
					viewBox="0 0 5472 3648">
					<image
						width={5472}
						height={3648}
						xlinkHref="/images/navbar/solution-2.jpg"
					/>
				</pattern>
				<pattern
					id="l-solution"
					width={1}
					height={1}
					viewBox="0 43.529 432.855 181.343">
					<image
						preserveAspectRatio="xMidYMid slice"
						width={479.528}
						height={319.665}
						xlinkHref="/images/navbar/solution-1.jpg"
					/>
				</pattern>
			</defs>
			<g transform="translate(0 -105)">
				<g transform="translate(492.612 -22.409)">
					<rect
						className="b-solution"
						width={1427.387}
						height={206.155}
						transform="translate(0 126.409)"
					/>
					<g transform="translate(0 126.409)">
						<g className="c-solution">
							<path
								className="d-solution"
								d="M1189.053,402.13l-.541-.21,41.367-92.276a55.308,55.308,0,0,1,21.556-24.336,61.508,61.508,0,0,1,32.454-9.135h184.873v.544H1283.888c-23.457,0-44.444,13.007-53.468,33.136Z"
								transform="translate(-5.245 -137.554)"
							/>
							<path
								className="d-solution"
								d="M369.429,0l.638.247L321.252,109.14a65.276,65.276,0,0,1-25.436,28.719,72.593,72.593,0,0,1-38.3,10.779H39.353V148H257.516c27.681,0,52.448-15.349,63.1-39.1Z"
								transform="translate(-0.174 -117.002)"
							/>
							<path
								className="e-solution"
								d="M1442.394,155.049,1386.479,279.8c-9.024,20.13-30.01,33.136-53.468,33.136h-28.562v0H1169.46A61.52,61.52,0,0,0,1137,322.063a55.312,55.312,0,0,0-21.555,24.336L581.086,471.147l.541.21L1115.99,346.61c9.025-20.13,30.012-33.136,53.47-33.136h28.562v0h134.99a61.522,61.522,0,0,0,32.455-9.135,55.319,55.319,0,0,0,21.556-24.336l55.913-124.748Z"
								transform="translate(-2.564 -128.54)"
							/>
						</g>
					</g>
				</g>
				<path
					className="b-solution"
					d="M367.709,339.246H0V0H586.714l-62.14,206.671a173.939,173.939,0,0,1-15.633,36.562c-36.385,63.36-89.124,96.013-141.232,96.013"
					transform="translate(0 104)"
				/>
				<g
					className="p-solution"
					transform="matrix(1, 0, 0, 1, -9, 98)">
					<path
						className="f-solution"
						d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
						transform="translate(9 -120.41)"
					/>
				</g>
				<g
					className="o-solution"
					transform="matrix(1, 0, 0, 1, -9, 98)">
					<path
						className="g-solution"
						d="M366,457.568H0V126.409H579.611L519,328.153a169.849,169.849,0,0,1-15.248,35.69C468.267,425.694,416.828,457.568,366,457.568"
						transform="translate(9 -120.41)"
					/>
				</g>
				<text className="h-solution" transform="translate(150 358)">
					<tspan x={0} y={0}>
						{'soluciones'}
					</tspan>
					<tspan x={0} y={37}>
						{'EN SALUD'}
					</tspan>
				</text>
				<path
					className="i-solution"
					d="M62.833,0,0,200.9H416.7L479.529,0Z"
					transform="translate(528 104)"
				/>
				<a href="/nuestros-aliados">
					<path
						className="j-solution"
						d="M62.833,0,0,200.9H416.7L479.529,0Z"
						transform="translate(528 104)"
					/>
				</a>
				<text className="k-solution" transform="translate(592 268)">
					<tspan x={16.86} y={24}>
						{'Nuestros ALIADOS'}
					</tspan>
				</text>
				<path
					className="l-solution"
					d="M496.655,0,433.822,200.9h416.7L913.352,0Z"
					transform="translate(516.455 104)"
				/>
				<path
					className="m-solution"
					d="M496.655,0,433.822,200.9h416.7L913.352,0Z"
					transform="translate(516.455 104)"
				/>
				<text className="k-solution" transform="translate(985 268)">
					<tspan x={9.136} y={24}>
						{'Mantenimiento Biom\xE9dico'}
					</tspan>
				</text>
				<path
					className="n-solution"
					d="M930.478,0,867.646,200.9h416.7L1347.174,0V0Z"
					transform="translate(504.909 104)"
				/>
				<a href="/productos">
					<path
						className="m-solution"
						d="M930.478,0,867.646,200.9h416.7L1347.174,0V0Z"
						transform="translate(504.909 104)"
					/>
				</a>
				<text className="k-solution" transform="translate(1409 268)">
					<tspan x={42.904} y={24}>
						{'soluciones EN SALUD'}
					</tspan>
				</text>
			</g>
		</svg>
	)
}

export default SubmenuSolution
